export default __webpack_public_path__ + "static/media/En-ciduad-destino.db75d56e.svg";